import { gql } from "@apollo/client";
import { IntegrationType } from "./companyIntegrationLimitation";

export const INTEGRATION_TYPES = gql`
query IntegrationTypes {
	company {
		integrationTypes {
			integration_type_id
			integration_name
			description
			access_level
		}
	}
}
`

export interface IntegrationTypesResponse {
	company: {
		integrationTypes: IntegrationType[]
	}
}
